(function () {
    'use strict';

    angular
        .module('app.gameTracker')
        .constant('gameTrackerRecoveryResolver', {
            data: getData
        });

    getData.$inject = ['GameTracker', '$transition$', 'user'];
    function getData(GameTracker, $transition$, user) {
        var params = $transition$.params(),
            individualId = params.individualId || user.id;
        return GameTracker.getRecoveryStatistics({ individualId: individualId, courseId: params.courseId, range: params.range }).$promise;
    }
})();